<template>
    <div class="publicacoes">
        <div class="publicar-para">
            <h2 class="subtitle">{{ $t('publicar-para') }}</h2>
            <div class="alvos">                
                <label class="check-box" for="admin"> {{ $t('admin') }}
                    <input type="checkbox" id="admin" v-model="alvos.admin"/>
                    <span class="checkmark" />
                </label>
                <label class="check-box" for="gestor" > {{ $t('gestor') }}
                    <input type="checkbox" id="gestor" v-model="alvos.gestor"/>
                    <span class="checkmark" />
                </label>
                <label class="check-box" for="vendedor"> {{$t('vendedor')}}
                    <input type="checkbox" id="vendedor" v-model="alvos.vendedor"/>
                    <span class="checkmark" />
                </label>
                <label class="check-box" for="promotor"> {{ $t('promotor') }}
                    <input type="checkbox" id="promotor" v-model="alvos.promotor"/>
                    <span class="checkmark" />
                </label>
            </div>
        </div>
        <div class="publicar-quando">
            <h2 class="subtitle">{{ $t('publicar-quando') }}</h2>
            <div class="data">
                <label class="radio-box" for="agora"> {{ $t('publicar-agora') }}
                    <input type="radio" id="agora" value="agora" v-model="formdata.publishwhen">
                    <span class="checkmark"></span>
                </label>
                <label class="radio-box" for="datahora"> {{ $t('publicar-data-escolhida') }}
                    <input type="radio" id="datahora" value="datahora" v-model="formdata.publishwhen">
                    <span class="checkmark"></span>
                </label>
                <div class="choose-datahora">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['formdata'],
    data() {
        return {
            campos: [1],
            alvos: {},
        }
    },
    created(){
    },
    components: {
    },
    methods: {
    }
};
</script>

<style lang="scss" scoped>
    .publicacoes{
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        height: 100%;
        .publicar-para{
            flex: 1 1 auto;
            padding-left: 15px;
            .alvos{
                display: flex;
                flex-wrap: wrap;
                .check-box{
                    margin-bottom: 25px;
                    color: $darker-gray-color;
                    font-weight: 600;
                }
            }
        }
        .publicar-quando{
            flex: 1 1 auto;
            padding-left: 15px;
            .radio-box{
                padding-bottom: 20px;
                color: $darker-gray-color;
            }
            .choose-datahora{
                width: 70%;
            }
        }
        h2{
            font-size: 16px;
            text-align: left;
            border-bottom: .75px solid $light-gray-color;
            padding-bottom: 10px;
            margin-bottom: 20px;
            font-weight: 500;
        }
    }

</style>
